import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';
import * as _ from "lodash";
import { Player } from '../../models/player';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  clock;
  playersCol;
  players;
  settingsDoc;
  settingsObs;
  settings;
  constructor(private afs: AngularFirestore,
              public afAuth: AngularFireAuth,
              public sharedService: SharedService,
              public router: Router) { }

  ngOnInit() {
    const that = this;
    this.clock = Observable.interval(1000).map(tick => new Date()).share();
    this.playersCol = this.afs.collection('players');
    this.players = this.playersCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    });
    this.settingsDoc = this.afs.doc('settings/' + 'yiEAeF7M7TGmk99TY1GC');
    this.settingsObs = this.settingsDoc.valueChanges();
    this.settings = this.settingsObs.subscribe(settings => {
      that.settings = settings;
    });
  }

  navigatePlayer(player) {
    this.router.navigate([player.id]);
  }

  getNameAbv(displayName) {
    let result = '';
    _.each(displayName.split(' '), function(word) {
      result += word[0].toUpperCase();
    });
    return result;
  }

  getStartLabel(clock) {
    if (!this.settings || !clock) { return null; }
    if (this.settings.startDateTime < clock.getTime()) {
      return 'Started';
    } else {
      const date = new Date(this.settings.startDateTime);
      return 'Starting in ' + this.getTimeLeft(this.settings.startDateTime, clock.getTime())
      + ' (' + this.getDateString(date) + ')';
    }
  }

  getEndLabel(clock) {
    if (!this.settings || !clock) { return null; }
    const date = new Date(this.settings.draftEndDateTime);
    if (this.settings.phaseTwoEndDateTime > clock.getTime()) {
      return this.getDateString(date);
    } else if (this.settings.draftEndDateTime > clock.getTime()) {
      return 'Draft ends in ' + this.getTimeLeft(this.settings.draftEndDateTime, clock.getTime())
      + ' (' + this.getDateString(date) + ')';
    } else {
      return 'Draft Ended';
    }
  }

  getPhaseOneLabel(clock) {
    if (!this.settings || !clock) { return null; }
    const date = new Date(this.settings.phaseOneEndDateTime);
    if (this.settings.startDateTime > clock.getTime()) {
      return this.getDateString(date);
    } else if (this.settings.phaseOneEndDateTime > clock.getTime()) {
      return this.getTimeLeft(this.settings.phaseOneEndDateTime, clock.getTime())
      + ' (' + this.getDateString(date) + ')';
    } else {
      return 'Phase Ended';
    }
  }

  getPhaseTwoLabel(clock) {
    if (!this.settings || !clock) { return null; }
    const date = new Date(this.settings.phaseTwoEndDateTime);
    if (this.settings.phaseOneEndDateTime > clock) {
      return this.getDateString(date);
    } else if (this.settings.phaseTwoEndDateTime > clock.getTime()) {
      return 'Phase 2 ends in ' + this.getTimeLeft(this.settings.phaseTwoEndDateTime, clock.getTime())
      + ' (' + this.getDateString(date) + ')';
    } else {
      return 'Phase Ended';
    }
  }

  getDateString(date) {
    return date.toLocaleDateString('en-US') + ' ' + date.getHours() + ':' + this.formatTimeNumber(date.getMinutes())
  }

  getTimeLeft(inputTimeStamp, inputCurrentDateTime) {
    const endtime = new Date(inputTimeStamp).getTime();
    const t = endtime - inputCurrentDateTime;
    const seconds = this.formatTimeNumber(Math.floor((t / 1000) % 60));
    const minutes = this.formatTimeNumber(Math.floor((t / 1000 / 60) % 60));
    const hours = this.formatTimeNumber(Math.floor((t / (1000 * 60 * 60)) % 24));
    return hours + ':' + minutes + ':' + seconds;
  }

  formatTimeNumber(input) {
    if (input.toString().length > 1) {
        return input;
    } else {
        return '0' + input;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts